<ng-container *ngIf="group && field">

  <div class="main-outer-container " [formGroup]="group" [hidden]="field.hidden || false">

    <div class="flex flex-col align-top my-2">
      <label for="{{field!.name}}" class="label col-sm-3 col-form-label">{{field.label}}</label>

      <textarea #inputEl [id]="field.name" [readonly]="field.readonly || false" [hidden]="field.hidden ||  false"
        [formControlName]="field.name" [ngClass]="field!.cssClass + 'e-input e-input-area transform duration-300 p-2'"
        [placeholder]="field.placeholder || ''" [class]="group.controls[field!.name].dirty ?
                  (group.controls[field.name].invalid ? 'danger' : 'success') : ''" [value]="field.value || ''"
        [attr.aria-invalid]="group.controls[field.name].invalid && group.controls[field.name].touched
                    ? true : null" (change)="onChangeValue($event)" (focus)="onFocus($event)"></textarea>
    </div>
    <!--OLD ngIf *ngIf="group.controls[field.name].dirty && group.controls[field.name].invalid"-->
    <div class="flex align-top flex-col" *ngIf="group.controls[field.name].dirty || group.controls[field.name].touched">
      <ng-container *ngFor="let validation of field!.validations;let i= index;">
        <div @slideDownUp *ngIf="group && field && group.controls[field.name].hasError(validation.name)"
          class=" p-2 flex justify-start items-center gap-2 bg-red-700/50 rounded-xl text-white font-bold">

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
            <path d="M12 8v4" />
            <path d="M12 16h.01" />
          </svg>

          <p>{{validation.message}}</p>
        </div>
      </ng-container>

    </div>
  </div>
</ng-container>